import { utils } from './-global.min.js'

class HHProductUpsell extends HTMLElement {
  constructor() {
    super()

    this.product_id = this.dataset.id
    this.product_url = this.dataset.url
    this.$addCheckbox = this.querySelector(`#show_upsell--${this.product_id}`)
    this.$upsellHero = this.querySelector('.upsell-item-hero')

    this.$addCheckbox.addEventListener(
      'change',
      this.loadContent.bind(this)
    )
  }

  loadContent() {
    this.classList.toggle('upsell-item-wrapper__active')
    if (this.$addCheckbox.checked) {
      fetch(
        `${this.product_url}?view=simple`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const content = new DOMParser().parseFromString(responseText, 'text/html')

          this.$upsellHero.classList.remove('upsell-item-hero__closed')
          this.$upsellHero.classList.add('upsell-item-hero__active')

          this.$upsellHero.appendChild(content.querySelector('.js-product-hero__carousel'))
          this.$upsellHero.appendChild(content.querySelector('.js-product-panel'))
                        // once everything is loaded, we click on queen if we can
          $('.js-upsell-item-hero .option__button--size').each(function() {
              var text = $(this).text();
             if (text.indexOf('Queen') > -1) {
               $(this).trigger('click');
             }
          });
        })
    } else {
      this.$upsellHero.classList.remove('upsell-item-hero__active')
      this.$upsellHero.classList.add('upsell-item-hero__closed')
      this.querySelector('.product-hero__carousel')?.remove()
      this.querySelector('.product-panel')?.remove()
    }
  }
}
customElements.define('hh-product-upsell', HHProductUpsell)